import * as React from 'react'

import './ExternalLink.css'

type SizeModifiers = "small" | "medium" | "large";

interface IExternalLinkProps {
    sizeModifier: SizeModifiers;

    source: string;
}

class ExternalLink extends React.Component<IExternalLinkProps, any> {
    public render() {
        return (
            <a className={"ExternalLink ExternalLink--" + this.props.sizeModifier} href={this.props.source} target="_blank">
                <i className="ExternalLink__icon material-icons">launch</i><span>{this.props.source}</span>
            </a>
        );
    }
}

export default ExternalLink;


// WEBPACK FOOTER //
// ./src/App/Elements/ExternalLink.tsx